import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { CreateThaiEventData, UpdateThaiEventData, thaiEventsApi } from '@/services';

export const adminThaiEventsKeys = {
  all: ['admin', 'thai-events'] as const,
  list: () => [...adminThaiEventsKeys.all, 'list'] as const,
};

export function useAdminThaiEventsListQuery() {
  return useQuery({
    queryKey: adminThaiEventsKeys.list(),
    queryFn: () => thaiEventsApi.getAll(),
  });
}

export function useAdminThaiEventQuery(id: number) {
  return useQuery({
    queryKey: [...adminThaiEventsKeys.all, 'detail', id] as const,
    queryFn: () => thaiEventsApi.getById(id),
    enabled: Number.isFinite(id),
  });
}

export function useCreateThaiEventMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateThaiEventData) => thaiEventsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminThaiEventsKeys.all });
    },
  });
}

export function useUpdateThaiEventMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateThaiEventData }) => thaiEventsApi.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: adminThaiEventsKeys.all });
      queryClient.invalidateQueries({
        queryKey: [...adminThaiEventsKeys.all, 'detail', variables.id],
      });
    },
  });
}

export function useDeleteThaiEventMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => thaiEventsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminThaiEventsKeys.all });
    },
  });
}
